import React, { FC } from 'react';

import classnames from 'classnames';
import { VideoDetail } from 'src/components/challenge/ChallengeVideoSection';
import { ExperienceDetailStatusEnum } from 'src/shared/enums';
import { IExperienceDetailWrapper } from 'src/shared/models';

export const QuizTypeformDetailWrapper: FC<IExperienceDetailWrapper> = ({
  status,
  button,
  quizDescription,
  quizImage,
  quizTitle,
  quizVideo,
}) => {
  const { DISABLED, IN_PROGRESS, DONE } = ExperienceDetailStatusEnum;
  const wrapperStatus = status ?? DISABLED;

  const showLabel = Boolean(button?.label && status === DONE);
  const showBtn = Boolean(
    button?.label && [DISABLED, IN_PROGRESS].includes(status)
  );
  const isButtonDisabled = Boolean(status === DISABLED);

  const quizClassnames = classnames('quizTypeform-content', {
    'quizTypeform--no-media': !quizImage && !quizVideo,
  });

  const handleClick = () => {
    if (!button.performAction) return;
    button.performAction();
  };

  const label = showLabel && (
    <div className="quizTypeform-content--btn">
      <label className={`quizTypeform-content--btn-label ${button.status}`}>
        {button.label}
      </label>
    </div>
  );

  const wrapperButton = showBtn && (
    <div
      className={`quizTypeform-content--btn ${button.status}`}
      onClick={handleClick}
    >
      <button
        disabled={isButtonDisabled}
        className={`ws-nowrap btn-cta btn-ghost btn--full-width ${
          isButtonDisabled ? 'btn-ghost--disabled' : ''
        }`}
      >
        {button.label}
      </button>
    </div>
  );

  return (
    <div className={`quizTypeform--wrapper ${wrapperStatus}`}>
      <div className={quizClassnames}>
        {quizVideo ? (
          <div className="quizTypeform-content--video">
            <VideoDetail
              customClassName="video-player"
              description=""
              id={quizVideo}
              imgDesktop={quizImage}
              imgMobile={quizImage}
              title=""
              type={2}
            />
          </div>
        ) : (
          <div className="quizTypeform-content--video image">
            {quizImage && (
              <img alt={quizTitle} loading="lazy" src={quizImage} />
            )}
          </div>
        )}
        <div className="quizTypeform-content--text">
          <h3 className="quizTypeform-content--title">{quizTitle}</h3>
          <p className="quizTypeform-content--description">{quizDescription}</p>
        </div>
        {wrapperButton}
        {label}
      </div>
    </div>
  );
};
